export const pushDataLayerEvent = (eventName, params = {}) => {
  if (typeof window === 'undefined') return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: eventName,
    ...params,
  });
};

export const trackButtonClick = (buttonName, extra = {}) => {
  pushDataLayerEvent('button_click', {
    button_name: buttonName,
    ...extra,
  });
};
